import { useMemo } from 'react';

const useObfuscateDashboardId = () => {
    const encode = (organizationUUID, dashboardId, seed) => {
        // Combine UUID, ID, and seed into a single string
        const combinedString = `${organizationUUID}:${dashboardId}:${seed}`;
        return btoa(combinedString); // Encode to Base64
    };

    const decode = (encodedString, seed) => {
        try {
            // Decode the Base64 string and split it back into components
            const [organizationUUID, dashboardId, decodedSeed] = atob(encodedString).split(':');
            if (decodedSeed !== seed.toString()) {
                throw new Error('Invalid seed');
            }
            return { organizationUUID, dashboardId: parseInt(dashboardId, 10) };
        } catch (error) {
            console.error('Failed to decode string:', error);
            return null;
        }
    };

    return useMemo(() => ({ encode, decode }), []);
};

export default useObfuscateDashboardId;